import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import Pagination from "react-js-pagination";
import {
  openChooseUserModal,
  fetchUserExceptAdmin,
  searchUserOutreach,
  clearUserExceptAdmin,
} from "DashboardOutreachAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { itemCount } from "Constants";
import UsersCell from "./userscell";
import LocaleStrings from "Languages";
import Loader from "Loader";

class ChooseUsersDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      allCheck: false,
      selectedUsers: props.speceficUsers,
      search: "",
    };
  }

  componentDidMount() {
    this.props.fetchUserExceptAdmin(this.props.session, 0, (res) => {
      this.checkMatchArray(this.state.selectedUsers);
    });
  }

  closeModal = () => {
    // console.log("called");
    this.props.openChooseUserModal(false);
    this.props.clearUserExceptAdmin();

    if (this.state.selectedUsers.length == 0) {
      this.props.categoryCallback("all");
      this.props.userSelectionCallback([]);
      // this.setState({ selectedUsers: [] });
    }
  };

  sendPush = (e) => {
    this.props.openChooseUserModal(false);
    this.props.clearUserExceptAdmin();

    this.props.userSelectionCallback(this.state.selectedUsers);
    // this.setState({ selectedUsers: [] });
  };

  onSearchUser = (event) => {
    let pageNumber = 1;
    var search = event.target.value;

    this.props.clearUserExceptAdmin();
    if (search == "") {
      this.props.fetchUserExceptAdmin(this.props.session, pageNumber, (res) => {
        this.checkMatchArray(this.state.selectedUsers);
      });
    } else {
      this.props.searchUserOutreach(
        this.props.session,
        search,
        pageNumber,
        (res) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }

    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;
    this.props.clearUserExceptAdmin();

    if (search == "") {
      this.props.fetchUserExceptAdmin(this.props.session, pageNumber, (res) => {
        this.checkMatchArray(this.state.selectedUsers);
      });
    } else {
      this.props.searchUserOutreach(
        this.props.session,
        search,
        pageNumber,
        (res) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }
    this.setState({ ...this.state, pageNumber });
  };

  // Selecting or removing one user at a time
  selectionCallback = (user) => {
    var selectedUsers = this.state.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      var selectedUser = { ...user, checked: true };
      selectedUsers = [...selectedUsers, selectedUser];

      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  // Here we are looping to show user who are visiable on screen only
  onSelectAll = () => {
    var state = this.state.allCheck;
    var selectedUsers = this.state.selectedUsers;
    var allUsers = this.props.userList.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }

        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.appuserid !== user.appuserid;
        });
        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  // This function is used to show or hide action option and check or uncheck master check field
  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      var userList = this.props.userList.data;

      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === appUser.appuserid;
        });

        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  renderUserList() {
    var selectedUsers = this.state.selectedUsers;
    var users = this.props.userList.data;
    // if(this.props.userList.data)
    //   users=this.props.userList.data.filter((user)=>(user.isadmin===false));

    var cells = [];

    _.map(users, (appUser, index) => {
      var selectedUser = selectedUsers.find(
        (curuser) => curuser.appuserid === appUser.appuserid
      );

      var checked = false;
      if (selectedUser) {
        checked = selectedUser.checked;
      }
      cells.push(
        <UsersCell
          key={appUser.appuserid}
          user={appUser}
          checked={checked}
          toggleSelection={this.selectionCallback}
        />
      );
    });

    return cells;
  }

  render() {
    var { userList } = this.props;
    var { selectedUsers, pageNumber, allCheck, search } = this.state;
    let hasData = false;
    if (userList.data) {
      hasData = true;
    }
    var disabled = true;
    var totalSelectedUsers = "";
    if (selectedUsers.length > 0) {
      disabled = false;
      totalSelectedUsers = "( " + selectedUsers.length + " )";
    }

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal === true ? true : false}
        onHide={this.closeModal}
        animation={true}
        dialogClassName="outreach-chooseusers-modal"
      >
        <Modal.Header>
          <div className="import-modal-title">
            {LocaleStrings.outreach_title_choose_user_to_sent_push}
          </div>

          <input
            className="form-control mapsearch"
            style={{ width: 142 }}
            placeholder={LocaleStrings.search}
            type="search"
            value={search}
            onChange={this.onSearchUser}
          />
          <button
            type="button"
            className="i-custom-cross-popup"
            onClick={() => this.closeModal()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
              alt="close"
            />
          </button>
        </Modal.Header>
        <Modal.Body style={{ minHeight: 530 }}>
          {hasData ? (
            <div>
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="custom-container-checkbox">
                        <input
                          type="checkbox"
                          onChange={this.onSelectAll}
                          checked={allCheck}
                        />
                        <span className="checkmark" />
                      </label>
                    </th>
                    <th>{LocaleStrings.outreach_table_list_name}</th>
                    {/* <th>Email</th> */}
                    {/* <th style={{paddingLeft: 6}}>{LocaleStrings.outreach_table_list_category}</th> */}
                  </tr>
                </thead>
                <tbody>{this.renderUserList()}</tbody>
              </table>
            </div>
          ) : (
            <div className="loader-container" style={{ minHeight: 470 }}>
              <Loader />
              <div className="loader-info">{LocaleStrings.preparingUsers}</div>
            </div>
          )}
          {userList && userList.count > itemCount ? (
            <Pagination
              activePage={pageNumber}
              itemsCountPerPage={itemCount}
              totalItemsCount={userList.count}
              pageRangeDisplayed={10}
              onChange={this.paginationCallback}
            />
          ) : null}
        </Modal.Body>
        {hasData ? (
          <Modal.Footer>
            <Button
              className="btn-custom-blue"
              type="button"
              disabled={disabled}
              onClick={this.sendPush}
            >
              {LocaleStrings.button_select} {totalSelectedUsers}
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.showChooseUserModal,
    userList: state.DashboardUserListWithoutAdmin,
    // user: state.user,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openChooseUserModal,
  fetchUserExceptAdmin,
  searchUserOutreach,
  clearUserExceptAdmin,
})(ChooseUsersDialog);
